<section class="file-upload">
  @if(!selectedFile || (selectedFile && fileSizeNum > 50)) {
  <input
    type="file"
    [accept]="fileType"
    class="file-upload-input"
    hidden
    #fileUploadInput
    (change)="getUploadedFile($event)"
  />
  <div class="file-upload-image" (click)="fileUploadInput.click()">
    <img src="assets/images/upload-solid2.svg" />
    <p>choose file to upload</p>
    <span>supported formats: {{fileType === '.csv' ? 'CSV' : 'xlsx'}}</span>
  </div>
  @if(fileSizeNum > 50) {
  <small>The FileSize must not exceed 50MB</small>
  } } @else {
  <div class="file-upload-file-details">
    <div class="file-info">
      @if(fileType === '.csv')
      {
        <img src="assets/images/csv.png" width="35" />
      } @else {
        <img src="assets/images/excel.png" width="35" />
      }
      <span>
        {{ selectedFile.name }} <br />
        <span>{{ fileSize }}</span>
      </span>
    </div>
    <span class="remove-file" (click)="removeFile()">&times;</span>
  </div>
  }
</section>
